import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class StarRatingComponent {
  @Input() rating: number = 0;
  @Input() readonly: boolean = true;
  @Input() size: number = 14;

  @Output() updatedRating: EventEmitter<number> = new EventEmitter<number>();

  range = [0, 1, 2, 3, 4];

  constructor(private ToastService: ToastService) {}

  fullStars(): number {
    return Math.floor(this.rating);
  }

  hasFullStar(index: number): boolean {
    return index < this.fullStars();
  }

  hasHalfStar(index: number): boolean {
    return this.rating > this.fullStars() && index === this.fullStars();
  }

  hasEmptyStar(index: number): boolean {
    return index >= this.fullStars();
  }

  rate(value: number): void {
    if (!this.readonly) {
      this.rating = value + 1;
      this.updatedRating.emit(this.rating);
    }
  }
}
